import React from "react";
import { Alert, Button } from "@mui/material";
import ShareTable from "../tables/ShareTable";
import { PageHeader } from "../dashboard/DashboardWidgets";
import { rowsOf } from "../../../api/services/records";

export function MigrationPage({ title, children }) {
  return <div dir="rtl" className="flex flex-col gap-xl pb-4xl"><PageHeader title={title} />
    {children}</div>;
}
export function RemoteTable({ resource, columns, params, setParams }) {
  return <>
    {resource.error && <Alert severity="error" action={<Button onClick={resource.reload}>دریافت دوباره</Button>}>{resource.error.message}</Alert>}
    <ShareTable data={rowsOf(resource.data)} columns={columns} getPage={{ loading: resource.loading, reFetch: () => {} }}
      pageShow={Boolean(setParams)} totalCount={resource.data?.count} page={Number(params?.get("page")) || 1} setPage={setParams} />
  </>;
}
export function Outcome({ data }) {
  if (!data) return null;
  return <section className="space-y-4" aria-live="polite">
    {data.message && <p>{data.message}</p>}
    {["sent", "total_numbers", "applied", "skipped", "failed", "invalid"].filter((key) => key in data).map((key) => {
      const labels = { sent: "ارسال‌شده", total_numbers: "تعداد شماره‌ها", applied: "ثبت‌شده", skipped: "ردشده", failed: "ناموفق", invalid: "نامعتبر" };
      return <div key={key}><h3>{labels[key]}: {Array.isArray(data[key]) ? data[key].length : data[key]}</h3>
        {Array.isArray(data[key]) && <ul className="list-disc ps-6">{data[key].map((item, index) =>
          <li key={index}>{typeof item === "object" ? Object.entries(item).map(([field, value]) => field + ": " + String(value)).join(" · ") : String(item)}</li>)}</ul>}
      </div>;
    })}
  </section>;
}
